import { useAtom } from 'jotai';
import { Box, BoxProps } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import * as kpiState from '../../state';
import { AggregationGroupBy } from '@/__generated__/graphql';
import { enumToString } from '@/utils/string';
import { usePersistKpiFilters } from '../../hooks/usePersistKpiFilters';

const OPTIONS = [
  AggregationGroupBy.Daily,
  AggregationGroupBy.Weekly,
  AggregationGroupBy.Monthly,
  AggregationGroupBy.Quarterly,
  AggregationGroupBy.Yearly,
];

type Props = {} & BoxProps;

export const KpiIntervalFilterButton = ({ ...rest }: Props) => {
  const { persistSelectedDateAggregationFilter } = usePersistKpiFilters();
  const [selectedDateAggregation, setSelectedDateAggregation] = useAtom(
    kpiState.selectedDateAggregation
  );

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value as AggregationGroupBy;
    if (!OPTIONS.includes(value)) return;
    persistSelectedDateAggregationFilter(value).then(() => {
      setSelectedDateAggregation(value);
    });
  };

  return (
    <Box {...rest}>
      <Select
        variant="outlined"
        value={selectedDateAggregation}
        sx={{ maxHeight: '3.5rem' }}
        onChange={handleChange}
        id="kpi-tracker-interval-filter-button"
      >
        {OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {enumToString(option)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
